import React from 'react';
import { Dialog, Typography } from '@material-ui/core';
import { CoreIcon, SecondaryButton } from '@clover/web-lib-core/components';
import { useTranslation } from 'react-i18next';
import styles from '../AppReviewsAndRatings/styles.module.scss';
import { DeveloperAppReview } from '../../../models/app';
import { CommentBody } from '../AppReviewsAndRatings/comment-body';
import { ButtonVariant } from '@clover/web-lib-core/dist/components/CoreButton/CoreButton';
import LoadingButton from '../../Common/LoadingButton';
import { DeleteReviewResponse } from '../../../models/post-req-responses-payloads';
import { useDeleteReviewMutation } from '../../../redux/api/appMarket-api-slice';
import { AppActionPostRequestResponseHandler, AppActions } from './types';
import { NotificationVariant } from '../../Common/Notifications/types';

interface ComponentProps {
  appId: Uuid;
  deleteReviewHandler: AppActionPostRequestResponseHandler<DeleteReviewResponse>
  editReviewHandler: () => void;
  open: boolean;
  onClose: () => void;
  review: DeveloperAppReview;
}

export const DeleteReviewModal = (props: ComponentProps):JSX.Element => {
  const [deleteReview, deleteReviewResult] = useDeleteReviewMutation();
  const { isLoading: isDeleting } = deleteReviewResult;
  const { onClose, open, review, editReviewHandler, appId, deleteReviewHandler } = props;
  const { id: reviewId, author, body, modifiedTime, starRating } = review;
  const { t } = useTranslation();
  const handleClose = () => {
    onClose();
  };

  const handleDelete = async () => {
    const reqResponse = await deleteReview({
      appId,
      reviewId
    });
    deleteReviewHandler({
      reqResponse,
      successNotification: {
        variant: NotificationVariant.Green,
        title: 'app_actions.banners.success_review_deleted',
      }
    });
  }

  return (
    <Dialog onClose={handleClose} open={open} maxWidth={false} disableEscapeKeyDown={true} PaperProps={{classes: {root: styles.deleteDialog}}}>
      <div className={styles.dialogHdr}>
        <Typography variant="h6" classes={{root: styles.dialogTitle}}>{t('app_details.delete_this_review_question')}</Typography>
        <div className={styles.closeIcon}>
          <CoreIcon
            onClick={handleClose}
            glyph="close"
            height={14}
            width={14}
            role="application"
            data-testid="closeButton"
          />
        </div>
      </div>
      <Typography variant="body1" gutterBottom>{t('app_details.delete_review_cant_recover')}</Typography>
      <CommentBody id={reviewId} author={author.name} body={body} modifiedTime={modifiedTime} isResponse={true} rating={starRating}/>
      <div className={styles.buttonContainer}>
        <LoadingButton isLoading={isDeleting} variant={ButtonVariant.PRIMARY} text={t(AppActions.DeleteReview)} isDisabled={isDeleting} onClick={handleDelete} hideTextWhileLoading={true}/>
        <SecondaryButton onClick={editReviewHandler}>{t('buttons.edit')}</SecondaryButton>
      </div>
    </Dialog>
  );
}
